import * as React from 'react';
import { ActivitySchedule, ActivityDefinition } from '../../../model/activities';
import { CalendarEvent } from '../BigCalendar';
import { CalendarDetail } from './CalendarDetail';
import { trainer } from '../../../model/trainer';

export const NewEventComponent = (props: { onCreate: (a: ActivitySchedule) => any, sourceActivity: ActivityDefinition, classes: any, onUndo: () => any, trainers: trainer[] }) => {
    /*    event: CalendarEvent;
    classes: any;
    onSave: (a: ActivitySchedule) => any;
    onDelete?: (id: string) => any;
    loading: boolean; */
    const a = props.sourceActivity;
    const now = new Date();
    now.setMinutes(0);
    now.setSeconds(0);
    const start = now;
    const end = new Date(now.setMinutes(60));
    const schedule: ActivitySchedule = {
        isReservable: a.isReservable,
        activityDefinitionId: a._id,
        date: start,
        displayName: a.displayName,
        description: a.description,
        duration: 60,
        capacity: 10,
        tag: a.tag,
        state: a.state,
        trainerIds: a.trainerIds
    }
    const event: CalendarEvent = {
        title: schedule.displayName,
        start: start,
        end: end,
        resource: schedule
    }
    return <CalendarDetail
        trainers={props.trainers}
        classes={props.classes}
        onSave={props.onCreate}
        loading={false}
        event={event}
        onUndo={props.onUndo}
        minDate={props.sourceActivity.validFrom}
        maxDate={props.sourceActivity.expiresOn} />
}